module.exports = __webpack_public_path__ + "static/media/09.c92fdd48.png";